import moment from 'moment'
import checkValidSepaInput from '@/modules/receipt/_helpers/checkValidSepaInput'

export class BankTransferFormModel {
  constructor(props = {}) {
    this.amount = props.amount || 0
    this.bankAccount = props.bankAccount || null
    this.accountHolder = props.accountHolder || null
    this.bic = props.bic || null
    this.iban = props.iban || null
    this.isIbanValid = props.isIbanValid || false
    this.payee = props.payee || null
    this.usage = props.usage || ''
    this.executionDate = props.executionDate || moment()
  }

  validate({ skipBic = false } = {}) {
    return this.amount > 0
            && this.bankAccount
            && (skipBic || !!this.bic)
            && !!this.iban
            && !!this.isIbanValid
            && !!this.payee
            && !!this.usage
            && !!this.executionDate
            && !!checkValidSepaInput(this.usage)
  }
}

export default BankTransferFormModel
